module.exports = __webpack_public_path__ + "./awon-illustration_29bafb66130b231617b0c0c10fae8e0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2015/awon-illustration.png
// module id = 418
// module chunks = 0